import React, { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { makeStyles } from "@material-ui/styles";
import {
  Card,
  CardContent,
  Grid,
  CardActions,
  Button,
  Divider,
  CardHeader,
  IconButton,
} from "@material-ui/core";
import Collapse from "@material-ui/core/Collapse";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import Input from "../Input";
import MalhaSelect from "../MalhaSelect";
import GerenciaSelect from "../GerenciaSelect";
import PoloSelect from "../PoloSelect";
import SubestacaoSelect from "../SubestacaoSelect";
import AlimentadorSelect from "../AlimentadorSelect";
import NsirStatusSelect from "../NsirStatusSelect";
import UsuarioSelect from "../UsuarioSelect";
import DatePicker from "../DatePicker";
import TrueFalseSelect from "../TrueFalseSelect";
import MultiSelect from "../MultiSelect";
import DateTypeSelect from "../DateTypeSelect";
import clsx from "clsx";

import * as selectorsAuth from "../../store/auth/reducer";
import * as selectors from "../../store/filtro/reducer";
import * as actions from "../../store/filtro/actions";
import * as Role from "../../constants/role";
import moment from "moment";
import OptionSelect from "components/OptionSelect";
import NsirSelect from "components/NsirSelect";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
    backgroundColor: theme.palette.bar.grayLight,
    overflow: "inherit",
  },
  cardActions: {
    padding: theme.spacing(2),
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
  cardHeader: {
    paddingTop: 10,
    paddingLeft: 16,
    paddingRight: 16,
    paddingBottom: 0,
    "&:hover": {
      cursor: "pointer",
    },
  },
  divider: {
    backgroundColor: theme.palette.bar.grayMiddle,
  },
  breakline: {
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    },
  }
}));

const fieldRenderers = {
  useDates: ({ filter, setFilter, md, xs, useDateTypes, useDateTypesReadOnly, classes }) => (
    <>
      <Grid item md={md || 2} xs={xs || 6}>
        <DatePicker
          label="Data Início"
          onChange={(data) => setFilter({ ...filter, inicio: data.valueOf() })}
          value={filter.inicio}
        />
      </Grid>
      <Grid item md={md || 2} xs={xs || 6}>
        <DatePicker
          label="Data Fim"
          onChange={(data) => setFilter({ ...filter, fim: data.valueOf() })}
          value={filter.fim}
        />
      </Grid>
      {useDateTypes ? (
        <Grid item md={8} xs={12}>
          <DateTypeSelect
            label="Filtro de datas"
            onSelect={(dateTypes) => setFilter({ ...filter, dateTypes })}
            value={filter.dateTypes}
            disabled={useDateTypesReadOnly}
          />
        </Grid>
      ) : <Grid className={classes.breakline} item xs={12} />}
    </>
  ),

  useCodigo: ({ filter, setFilter, codigoLabel, md, xs }) => (
    <Grid item md={md || 2} xs={xs || 6}>
      <Input
        label={codigoLabel || "Código"}
        onChange={(e) => setFilter({ ...filter, codigo: e.target.value })}
        value={filter.codigo}
      />
    </Grid>
  ),

  useEquipamento: ({ filter, setFilter, md, xs }) => (
    <Grid item md={md || 2} xs={xs || 6}>
      <Input
        label="Equipamento"
        onChange={(e) => setFilter({ ...filter, equipamento: e.target.value })}
        value={filter.equipamento}
      />
    </Grid>
  ),

  useUsuarios: ({ filter, setFilter, multiSelect, label = "Usuários", grupos, disabled, md, xs }) => (
      <Grid item md={md || 2} xs={xs || 6}>
        <UsuarioSelect
          label={label}
          onSelect={(usuarioId) => setFilter({ ...filter, usuarioId })}
          multiSelect={multiSelect}
          value={filter.usuarioId}
          grupos={grupos}
          disabled={disabled}
        />
      </Grid>
    ),

  useInspetor: ({ filter, setFilter, multiSelect, userRole, md, xs }) =>
    Role.INSPETOR !== userRole && (
      <Grid item md={md || 2} xs={xs || 6}>
        <UsuarioSelect
          label="Inspetor"
          onSelect={(inspetorId) => setFilter({ ...filter, inspetorId })}
          multiSelect={multiSelect}
          grupos={[Role.ADMIN, Role.INSPETOR]}
          value={filter.inspetorId}
        />
      </Grid>
    ),

  useInspetorAuxiliar: ({ filter, setFilter, multiSelect, userRole, md, xs }) =>
    Role.INSPETOR !== userRole && (
      <Grid item md={md || 2} xs={xs || 6}>
        <UsuarioSelect
          label="Inspetor Auxiliar"
          onSelect={(inspetorAuxiliarId) =>
            setFilter({ ...filter, inspetorAuxiliarId })
          }
          multiSelect={multiSelect}
          grupos={[Role.ADMIN, Role.INSPETOR]}
          value={filter.inspetorAuxiliarId}
        />
      </Grid>
    ),

  useDigitador: ({ filter, setFilter, disabled = false, md, xs, multiSelect }) => {
    return (
      <Grid item md={md || 12} xs={xs || 12}>
        <UsuarioSelect
          label="Digitador(es)"
          onSelect={digitadorId => setFilter({ ...filter, digitadorId })}
          grupos={[Role.ADMIN, Role.DIGITADOR]}
          value={filter.digitadorId}
          disabled={disabled}
          multiSelect={multiSelect}
        />
      </Grid>
    )
  },

  useMalha: ({ filter, setFilter, md, xs }) => (
    <Grid item md={md || 3} xs={xs || 6}>
      <MalhaSelect
        onSelect={(value) =>
          setFilter({
            ...filter,
            malhaId: value,
            gerenciaId: null,
            poloId: null,
            subestacaoId: null,
            alimentadorId: null,
          })
        }
        value={filter.malhaId}
      />
    </Grid>
  ),

  useGerencia: ({ filter, setFilter, md, xs }) => (
    <Grid item md={md || 2} xs={xs || 6}>
      <GerenciaSelect
        onSelect={(value) =>
          setFilter({
            ...filter,
            gerenciaId: value,
            poloId: null,
            subestacaoId: null,
            alimentadorId: null,
          })
        }
        value={filter.gerenciaId}
        malhaId={filter.malhaId}
      />
    </Grid>
  ),

  usePolo: ({ filter, setFilter, md, xs }) => (
    <Grid item md={md || 3} xs={xs || 6}>
      <PoloSelect
        onSelect={(value) =>
          setFilter({
            ...filter,
            poloId: value,
            subestacaoId: null,
            alimentadorId: null,
          })
        }
        value={filter.poloId}
        malhaId={filter.malhaId}
        gerenciaId={filter.gerenciaId}
      />
    </Grid>
  ),

  useSubestacao: ({ filter, setFilter, md, xs }) => (
    <Grid item md={md || 2} xs={xs || 6}>
      <SubestacaoSelect
        onSelect={(value) =>
          setFilter({ ...filter, subestacaoId: value, alimentadorId: null })
        }
        value={filter.subestacaoId}
        malhaId={filter.malhaId}
        gerenciaId={filter.gerenciaId}
        poloId={filter.poloId}
      />
    </Grid>
  ),

  useAlimentador: ({ filter, setFilter, md, xs }) => (
    <Grid item md={md || 2} xs={xs || 6}>
      <AlimentadorSelect
        onSelect={(value) => setFilter({ ...filter, alimentadorId: value })}
        value={filter.alimentadorId}
        malhaId={filter.malhaId}
        gerenciaId={filter.gerenciaId}
        poloId={filter.poloId}
        subestacaoId={filter.subestacaoId}
      />
    </Grid>
  ),

  usePossuiCroqui: ({ filter, setFilter, md, xs }) => (
    <Grid item md={md || 2} xs={xs || 6}>
      <TrueFalseSelect
        label="Possui Croqui"
        onChange={(e) => setFilter({ ...filter, possuiCroqui: e.target.value })}
        value={filter.possuiCroqui}
      />
    </Grid>
  ),

  useNsirPagaInspetor: ({ filter, setFilter, md, xs }) => (
    <Grid item md={md || 2} xs={xs || 6}>
      <TrueFalseSelect
        label="Nsir Paga Inspetor"
        onChange={(e) =>
          setFilter({ ...filter, nsirPagaInspetor: e.target.value })
        }
        value={filter.nsirPagaInspetor}
      />
    </Grid>
  ),

  useCliente: ({ filter, setFilter, md, xs }) => (
    <Grid item md={md || 2} xs={xs || 6}>
      <OptionSelect
        label="Clientes"
        codigo="CLIENTE"
        multiSelect
        onSelect={(values) => setFilter({ ...filter, clientes: values })}
        value={filter.clientes}
      />
    </Grid>
  ),

  useNsirStatus: ({ filter, setFilter, customStatus, md, xs, multiSelect = true }) => (
    <Grid item md={md || 12} xs={xs || 12}>
      <NsirStatusSelect
        onSelect={statuses => setFilter({ ...filter, statuses })}
        value={filter.statuses}
        isMultiple={multiSelect}
        options={customStatus}
      />
    </Grid>
  ),

  useTipoServico: ({ filter, setFilter, md, xs, multiSelect = true }) => (
    <Grid item md={md || 2} xs={xs || 6}>
      <OptionSelect
        label="Tipo de Serviços"
        codigo="TIPO_SERVICO"
        multiSelect={multiSelect}
        onSelect={tipoServicos => setFilter({ ...filter, tipoServicos })}
        value={filter.tipoServicos}
      />
    </Grid>
  ),

  useSubTipoServico: ({ filter, setFilter, md, xs, multiSelect = true }) => (
    <Grid item md={md || 2} xs={xs || 6}>
      <OptionSelect
        label="Subtipo de Serviços"
        codigo="NSIR_SUBTIPOS"
        multiSelect={multiSelect}
        onSelect={subTipoIds => setFilter({ ...filter, subTipoIds })}
        value={filter.subTipoIds}
      />
    </Grid>
  ),

  useClientes: ({ filter, setFilter, md, xs, multiSelect = true }) => (
    <Grid item md={md || 2} xs={xs || 6}>
      <OptionSelect
        label="Clientes"
        codigo="CLIENTE"
        multiSelect={multiSelect}
        onSelect={clienteIds => setFilter({ ...filter, clienteIds })}
        value={filter.clienteIds}
      />
    </Grid>
  ),

  useOption: ({ filter, setFilter, code, label, key, md, xs, multiSelect = true }) => (
    <Grid item md={md || 2} xs={xs || 6}>
      <OptionSelect
        label={label}
        codigo={code}
        multiSelect={multiSelect}
        onSelect={(values) => setFilter({ ...filter, [key]: values })}
        value={filter[key]}
      />
    </Grid>
  ),

  useMultiSelectCustomOption: ({ filter, setFilter, options, label, key, md, xs }) => (
    <Grid item md={md || 2} xs={xs || 6}>
      <MultiSelect
        label={label}
        onChange={values => setFilter({ ...filter, [key]: values ? values.map(v => v.value) : [] })}
        value={filter[key]}
        options={options}
      />
    </Grid>
  ),

  useMesReferencia: ({ filter, setFilter, md, xs }) => (
    <Grid item md={md || 2} xs={xs || 6}>
      <DatePicker
        label="Mês Referência"
        yearMonth
        showInput
        onChange={(data) => setFilter({ ...filter, mesReferencia: data ? moment(data).format('YYYY-MM') : null })}
        value={filter.mesReferencia ? moment(filter.mesReferencia, 'YYYY-MM').valueOf() : null}
      />
    </Grid>
  ),

  useNsirs: ({ filter, setFilter, label = "Nsirs", key = "nsirIds", md, xs, multiSelect = true }) => (
    <Grid item md={md || 2} xs={xs || 6}>
      <NsirSelect
        label={label}
        multiSelect={multiSelect}
        onSelect={(values) => setFilter({ ...filter, [key]: values })}
        value={filter[key]}
        defaultValue={filter[key]}
      />
    </Grid>
  ),
};

const CustomFilter = ({
  fields = [],
  onFilter,
  userRole,
  defaultFilter = {},
  defaultCollapseValue = false,
  defaultCollapseUnmountOnExit = true,
  confirmButtonText = "Filtrar",
}) => {
  const classes = useStyles();

  const [filter, setFilter] = useState(defaultFilter);
  const [expanded, setExpanded] = useState(defaultCollapseValue);

  return (
    <Card className={classes.root}>
      <CardHeader
        className={classes.cardHeader}
        title="Filtros"
        onClick={() => {
          if (defaultCollapseUnmountOnExit) setExpanded(!expanded)
        }}
        action={
          <IconButton
            className={clsx(classes.expand, {
              [classes.expandOpen]: expanded,
            })}
            onClick={() => {
              if (defaultCollapseUnmountOnExit) setExpanded(!expanded)
            }}
          >
            <ExpandMoreIcon />
          </IconButton>
        }
      />
      <Collapse in={expanded} timeout="auto" unmountOnExit={defaultCollapseUnmountOnExit}>
        <CardContent>
          <Grid container spacing={2}>
            {fields.map(({ field, ...rest }, idx) => {
              const Renderer = fieldRenderers[field];
              if (!Renderer) return null;
              return (
                <React.Fragment key={idx}>
                  {Renderer({
                    filter,
                    setFilter,
                    userRole,
                    classes,
                    ...rest,
                  })}
                </React.Fragment>
              );
            })}
          </Grid>
        </CardContent>
        <Divider className={classes.divider} />
        <CardActions className={classes.cardActions}>
          <Button
            color="primary"
            size="small"
            variant="contained"
            onClick={() => {
              if (!filter.status) filter.status = null;
              return onFilter(filter);
            }}
          >
            {confirmButtonText}
          </Button>
          <Button
            color="primary"
            size="small"
            variant="contained"
            onClick={() => {
              setFilter(defaultFilter);
            }}
          >
            Limpar
          </Button>
        </CardActions>
      </Collapse>
    </Card>
  );
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({
      ...actions,
  }, dispatch);

const mapStateToProps = (state) => ({
  cacheFiltroNsir: selectors.getCacheFiltroNsir(state),
  userRole: selectorsAuth.getRole(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomFilter);
